import React from "react"
import Video from "../video"

const VideoZone = () => {
  return (
    <>
      <div className="grid grid-cols-12">
        <div className="col-span-12 text-center">
          <h2 className="text-4xl text-gray-800 font-medium">Conoce a Alex</h2>
        </div>
        <div className="col-span-12">
          <Video
            videoSrcURL="https://www.youtube.com/embed/GLBBKuP96Lw?autoplay=0&rel=0&showinfo=0"
            videoTitle="Official Music Video on YouTube"
          />
        </div>
      </div>
    </>
  )
}

export default VideoZone
